<template>
  <a-space class="nav-no-title">
    <a-select class="long-select"
              :options="albumList"
              v-model:value="k"
              show-search
              @change="query"/>
    <a-button type="dashed" @click="clearCk">清除缓存</a-button>
    <a-dropdown v-model:open="updTip">
      <a-button>批量操作</a-button>
      <template #overlay>
        <a-menu>
          <a-menu-item>
            <a-space direction="vertical">
              <a-radio-group v-model:value="target" name="radioGroup">
                <a-radio value="0">库存</a-radio>
                <a-radio value="1">概率</a-radio>
              </a-radio-group>

              <a-input-group compact>
                <a-input-number min="0" v-model:value="num"/>

                <a-button type="primary" @click="multiUpd">一键修改</a-button>
              </a-input-group>

              <a-typography-text>修改后点击保存生效</a-typography-text>
            </a-space>
          </a-menu-item>
          <a-menu-item>
            <a-space>
              <a-button :loading="loading" @click="stockSaveCk">保存库存</a-button>
              <a-button type="dashed" :loading="loading" @click="chanceSaveCk">保存概率</a-button>
            </a-space>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <a-button type="primary" @click="addCk">添加</a-button>
    <a-button @click="sortCk">排序</a-button>
    <a-button @click="query" :loading="loading">刷新</a-button>
  </a-space>

  <a-table size="small"
           :columns="columns"
           :data-source="source"
           :loading="loading"
           :pagination="false">
    <template v-slot:bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'frontThumb'">
        <a-image :src="record.frontThumb" :height="30"/>
      </template>

      <template v-else-if="column.dataIndex === 'backThumb'">
        <a-image :src="record.backThumb" :height="30"/>
      </template>

      <template v-else-if="column.dataIndex === 'stock'">
        <a-input-number size="small" min="0" v-model:value="record.stock"/>
      </template>

      <template v-else-if="column.dataIndex === 'chance'">
        <a-input-number size="small" min="0" v-model:value="record.chance"/>
      </template>

      <template v-else-if="column.dataIndex === 'limit'">
        <a-space>
          <div>{{ record.reach }} / {{ record.limit }}</div>

          <a-button type="link" @click="serialViewCk(record)">查看</a-button>
        </a-space>
      </template>

      <template v-else-if="column.dataIndex === 'state'">
        <a-space>
          <template v-if="record.state === 1">
            <a-tag :bordered="false">正常</a-tag>
            <a-button v-if="store.state.auth.group === 0" size="small" @click="stateCk(record, 2)">上架</a-button>
          </template>
          <template v-else>
            <a-tag :bordered="false" color="green">上架</a-tag>
            <a-button v-if="store.state.auth.group === 0" size="small" danger @click="stateCk(record, 1)">下架</a-button>
          </template>
        </a-space>
      </template>

      <template v-else-if="column.dataIndex === 'act'">
        <a-space>
          <a-button @click="serialCk(record)" size="small">修改编号</a-button>
          <a-button @click="updCk(record)" size="small">编辑</a-button>
          <a-button danger @click="delCk(record)" size="small">删除</a-button>
        </a-space>
      </template>

      <template v-else>
        {{ record[column.dataIndex] }}
      </template>
    </template>
  </a-table>

  <add-modal ref="add" @refresh="query"/>

  <upd-modal ref="upd" @refresh="query"/>

  <sort-modal ref="sort" @refresh="query"/>

  <serial-modal ref="serial" @refresh="query"/>

  <serial-view-modal ref="serialView"/>
</template>

<script setup>
import {ref} from 'vue'
import {message, Modal} from 'ant-design-vue'
import {useStore} from 'vuex'
import axios from '@/axios'

import AddModal from '@/views/card/Add.vue'
import UpdModal from '@/views/card/Upd.vue'
import SortModal from '@/components/Sort.vue'
import SerialModal from '@/views/card/Serial.vue'
import SerialViewModal from '@/views/card/SerialView.vue'

const store = useStore()

const k = ref(0)
const target = ref('0')
const num = ref(0)

const loading = ref(false)
const updTip = ref(false)

const add = ref(null)
const upd = ref(null)
const sort = ref(null)
const serialView = ref(null)
const serial = ref(null)

const albumList = ref([])
const source = ref([])

const columns = [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
  }, {
    key: 'pid',
    title: '父级ID',
    dataIndex: 'pid',
  }, {
    key: 'name',
    title: '名称',
    dataIndex: 'name',
  }, {
    key: 'frontThumb',
    title: '正面',
    dataIndex: 'frontThumb',
  }, {
    key: 'backThumb',
    title: '背面',
    dataIndex: 'backThumb',
  }, {
    key: 'state',
    title: '状态',
    dataIndex: 'state',
  }, {
    key: 'rare',
    title: '稀有度',
    dataIndex: 'rare',
  }, {
    key: 'stock',
    title: '库存',
    dataIndex: 'stock',
  }, {
    key: 'chance',
    title: '概率',
    dataIndex: 'chance',
  }, {
    key: 'limit',
    title: '限编',
    dataIndex: 'limit',
  }, {
    key: 'require',
    title: '素材数',
    dataIndex: 'require',
  }, {
    key: 'act',
    title: '操作',
    dataIndex: 'act',
  }
]

function query() {
  loading.value = true
  axios.get('/card', {
    params: {
      album: k.value
    }
  }).then((res) => {
    if (res.code === 1) {
      source.value = res.data
      loading.value = false
    }
  })
}

function option() {
  axios.get('/album-opt').then((res) => {
    if (res.code === 1) {
      albumList.value = res.data
      if (albumList.value.length) {
        k.value = albumList.value[0].value
      }
      query()
    }
  })
}

function multiUpd() {
  if (target.value === '0') {
    for (const i of source.value) {
      i.stock = num.value
    }
    return
  }

  for (const i of source.value) {
    i.chance = num.value
  }
}

function addCk() {
  add.value.openCk(k.value)
}

function sortCk() {
  sort.value.openCk(`/card/sort?album=${k.value}`)
}

function clearCk() {
  axios.delete(`/album/${k.value}`).then((res) => {
    if (res.code === 1) {
      message.success('操作成功')
    }
  })
}

function stockSaveCk() {
  if (loading.value) {
    return
  }

  loading.value = true
  let tmp = {}
  for (const i of source.value) {
    tmp[i.id] = i.stock
  }
  axios.post('/card-stock', {
    map: tmp,
  }).then((res) => {
    loading.value = false
    if (res.code === 1) {
      message.success('操作成功')
      query()
    }
  })
}

function chanceSaveCk() {
  if (loading.value) {
    return
  }

  loading.value = true
  let tmp = {}
  for (const i of source.value) {
    tmp[i.id] = i.chance
  }
  axios.post('/card-chance', {
    map: tmp,
  }).then((res) => {
    loading.value = false
    if (res.code === 1) {
      message.success('操作成功')
      query()
    }
  })
}

function serialViewCk(record) {
  serialView.value.openCk(record.id)
}

function serialCk(record) {
  serial.value.openCk(record.id)
}

function updCk(record) {
  upd.value.openCk(k.value, record)
}

function delCk(record) {
  Modal.confirm({
    content: '确定删除吗？',
    okText: '删除',
    okType: 'danger',
    cancelText: '取消',
    onOk() {
      axios.post(`/card/${record.id}/state`, {
        state: 0
      }).then((res) => {
        if (res.code === 1) {
          message.success('操作成功')
          query()
        }
      })
    },
  })
}

function stateCk(record, state) {
  Modal.confirm({
    content: '确定' + (state === 1 ? '下架' : '上架') + '吗？',
    okText: '继续',
    cancelText: '取消',
    onOk() {
      axios.post(`/card/${record.id}/state`, {
        state: state
      }).then((res) => {
        if (res.code === 1) {
          message.success('操作成功')
          query()
        }
      })
    },
  })
}

option()
</script>
